import React from 'react';

/**
 * Primary Button
 *
 * @returns {JSX.Element}
 * @constructor
 * @param label
 * @param clickHandler
 * @param withIcon
 */
const PrimaryButton = ({ children, onClick, withIcon = true }) => {
  return (
    <a className="button button--secondary button--secondary-quickcheck" href="#" onClick={onClick}>
      { withIcon && (
      <svg className="icon icon--arrow-right button__icon" viewBox="0 0 200 200">
        <use xlinkHref="#icon-arrow-right"></use>
      </svg>
      )}
      <span className="button__text">{children}</span>
    </a>
  );
}

export default PrimaryButton;
